import z from 'zod';

export enum SubjectLevel {
  YEAR_7 = 'YEAR_7',
  YEAR_8 = 'YEAR_8',
  YEAR_9 = 'YEAR_9',
  YEAR_10 = 'YEAR_10',
  YEAR_11 = 'YEAR_11',
  GCSE = 'GCSE',
  A_LEVEL = 'A_LEVEL',
}

export const subjectLevelSchema = z.enum(SubjectLevel);
